import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DAlert from '../../DAlert';
import DButton from '../../DButton';
export default function DefaultErrorBoundary({ resetErrorBoundary }) {
    return (_jsx(DAlert, { color: "danger", showClose: false, children: _jsxs("div", { className: "d-flex align-items-center gap-2", children: [_jsx("span", { children: "An unexpected error occurred." }), _jsx(DButton, { color: "secondary", variant: "outline", size: "sm", onClick: resetErrorBoundary, children: "Retry" })] }) }));
}
//# sourceMappingURL=DefaultErrorBoundary.js.map